<template>
    <div class="responsive-note">
        <h3 class="mt-12 font-weight-black">Gerar magic-link</h3>

        <v-card class="mt-5 d-flex align-start" width="1219" height="130">
            <div class="rounded borderGreen"
                style="height: 120px; width: 3px !important; background-color: var(--green); margin: 5px"></div>
            <div class="">
                <span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url</span>
                <span class="d-flex align-center">
                    <input placeholder="Insire a URL longa aqui." v-model="urlLong"
                        class="mt-3 pl-2 responsive-input-long"
                        style="border: 2px solid var(--grey-day-020); height: 48px; width: 900px; margin-left: 40px; margin-right: 20px; border-radius: 4px"
                    >

                    <v-btn width="226" height="48" class="mt-2" :disabled="urlLong === ''"
                        :style="urlLong !== '' ? 'background: var(--red); color: var(--white)' : 'background: var(--white); color: var(--black)'"
                        @click="handleGenerateMagicLink">
                        <span class="pl-3 ff">Gerar magic-link</span>
                    </v-btn>
                </span>
            </div>
        </v-card>

        <transition name="slide">
            <v-card v-if="magicLinkResult" class="mt-5 d-flex align-start" width="1219" height="130">
                <div class="rounded borderGreen"
                    style="height: 120px; width: 3px !important; background-color: var(--blue); margin: 5px"></div>
                <div class="">
                    <span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Magic-link</span>
                    <span class="d-flex align-center">
                        <input v-on:focus="$event.target.select()" ref="clone" v-model="magicLinkResult"
                            class="mt-3 d-flex align-center pa-5 responsive-input-short"
                            style="border: 2px solid var(--grey-day-020); height: 48px; width: 975px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)" />
                        <v-btn width="150" height="48" class="mt-2" @click="copy" color="var(--red)">
                            <img src="../../../../static/images/square_white.svg" />
                            <span class="pl-3 ff" style="color: var(--white)">{{ copyText }}</span>
                        </v-btn>
                    </span>
                </div>
            </v-card>
        </transition>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    data () {
        return {
            urlLong: '',
            magicLinkResult: '',
            copyText: 'Copiar',
        }
    },
    methods: {
        ...mapMutations('Shared', {
            setToaster: 'SET_TOASTER'
        }),
        handleGenerateMagicLink() {
            try {
                this.magicLinkResult = `${process.env.ACCOUNTS}/magic-link?urlToken=%%magiclink%%&next=${encodeURIComponent(this.urlLong)}`;

                this.toaster(
                    'Magic-link gerado com sucesso!',
                    'var(--green)',
                    true
                );
            } catch (err) {
                this.toaster('Ocorreu um erro ao gerar o magic-link.', 'red accent-2', true);
            }
        },
        copy() {
            try {
                this.$refs.clone.focus();
                document.execCommand('copy');
                this.copyText = 'Copiado!';
                this.toaster('Texto copiado com sucesso!', 'var(--green)', true);
                setTimeout(() => {
                    this.copyText = 'Copiar';
                }, 2000);
            } catch (err) {
                this.toaster('Ocorreu um erro ao copiar o texto.', 'red accent-2', true);
            }
        },
        toaster(message, color, visible) {
            this.setToaster({
                message,
                color,
                visible
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Contents/UrlTools/MagicLinkGenerator.vue